export enum OAuthTrackEventName {
  FlowStarted = 'OAuth Flow Started',
  ProviderAuthenticated = 'OAuth Provider Authenticated',
  FlowFailed = 'OAuth Flow Failed',
}

export type OAuthProvider = 'google' | 'facebook' | 'apple';

export type OAuthSourceScreen = 'login' | 'register';

export type OAuthErrorType = 'user_cancelled' | 'provider_error' | 'network_error';
